module.exports = __webpack_public_path__ + "img/icon_list_good_selected.02716819.svg";